import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

interface LoadingSpinnerProps {
  size?: "sm" | "md" | "lg";
  text?: string;
  className?: string;
}

export const LoadingSpinner = ({ size = "md", text, className }: LoadingSpinnerProps) => {
  const sizeClasses = {
    sm: "h-3 w-3",
    md: "h-4 w-4", 
    lg: "h-6 w-6"
  };

  const textClasses = {
    sm: "text-xs",
    md: "text-sm",
    lg: "text-base"
  };

  return (
    <div className={cn("flex flex-col items-center justify-center gap-1", className)}>
      <Loader2 className={cn("animate-spin text-orange-600", sizeClasses[size])} />
      {text && (
        <p className={cn("text-orange-600 font-medium", textClasses[size])}>
          {text}
        </p>
      )}
    </div>
  );
};